import React from 'react';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';
import { graphql } from 'gatsby';

import PageHeader from '../components/PageHeader';
import TagLink from '../components/TagLink';
import SiteTitle from '../containers/SiteTitle';
import Layout from '../layouts';

const TagList = styled('ul')`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
`;

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
  },
  location,
}) => (
  <Layout location={location}>
    <SiteTitle />
    <PageHeader header="Tags" />
    <TagList>
      {group.map(tag => (
        <li key={tag.fieldValue}>
          <TagLink tag={tag.fieldValue} /> x{tag.totalCount}
        </li>
      ))}
    </TagList>
  </Layout>
);

TagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
};

export default TagsPage;

export const pageQuery = graphql`
  query TagsQuery {
    allMarkdownRemark(
      limit: 2000
      filter: { frontmatter: { draft: { ne: true } } }
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
